<template>
  <div :class="['sj-question-file', disabled?'disabled':'']"
       tabindex="0">
    <ul>
      <slot></slot>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'SjQuestionFile',
  components: {},
  mixins: [],
  provide () {
    return {
      sjQuestionFile: this
    }
  },
  inject: [],
  props: {
    model: Array,
    disabled: Boolean,
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {},
}
</script>
<style lang="scss">
.sj-question-file {
  border-radius: 4px;
  background-color: white;
  min-height: 94px;
  border: 1px solid #dcdfe6;
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);

  &.disabled {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #c0c4cc;
  }

  &:hover {
    border-color: #c0c4cc;
  }

  &:focus {
    border-color: #409EFF;
  }

  & > ul {
    margin: 0;
    padding: 0;
    list-style-type: none;

    li.sj-question-file-item {
      float: left;
      cursor: pointer;
      margin: 10px;
      width: 75px;
      height: 75px;
    }

    &::after {
      content: "";
      display: block;
      clear: both;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/question-editor/packages/sj-question-file/src/SjQuestionFile.vue